import { Combobox } from "@/src/components/ui/combobox";
import { Label } from "@/src/components/ui/label";
import { useFormContext } from "react-hook-form";
import { extractFromMultiName } from "../utils";

export function RelationSingleInput({
  name,
  label,
  loadOptions,
}: {
  name: string;
  label: string;
  loadOptions: (query: string) => Promise<{ id: string; names: string }[]>;
}) {
  const { control, setValue, watch } = useFormContext();
  const value = watch(name);

  return (
    <div className="flex flex-col gap-1">
      <Label>{label}</Label>
      <Combobox<{ id: string; names: string }>
        className="w-80"
        loadOptions={loadOptions}
        value={value}
        renderOption={(v) => extractFromMultiName(v.names)}
        onChange={(v) => setValue(name, v)}
        placeholder={`Select ${label.toLowerCase()}`}
      />
    </div>
  );
}
